import { render, staticRenderFns } from "./Logout.icon.vue?vue&type=template&id=448f3768&"
import script from "./Logout.icon.vue?vue&type=script&lang=js&"
export * from "./Logout.icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports